import { createFileRoute } from '@tanstack/react-router'

import { FollowUpReportScreen } from './-components/follow-up-report-screen.tsx'

export const Route = createFileRoute('/cs-tools/follow-up-report')({
  component: FollowUpReportScreen
})
